import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, Button, Heading, Panel, Separator, Text } from "@nju/ui";

interface IGeneratePasswordProps {
  isLoading: boolean;
  generatePassword: () => void;
}

export function GeneratePassword({
  isLoading,
  generatePassword,
}: IGeneratePasswordProps) {
  return (
    <Panel>
      <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
        zmiana hasła do konfiguracji modemu
      </Heading>
      <Separator size="xs" tone="invisible" />
      <Text
        size={{
          "@onlyMobile": "s",
        }}
      >
        Za chwilę wygenerujemy dla Ciebie nowe hasło do konfiguracji modemu
        FunBox 3.0. Hasło nie zostanie nigdzie zapisane, dlatego wygeneruj je w
        momencie konfiguracji modemu i wpisz od razu w odpowiednie miejsce.
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex only-mobile:flex-col-reverse from-tablet:justify-between">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "ftth" })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="secondary"
          >
            anuluj
          </A>
        </Link>
        <Separator
          size={{
            "@onlyMobile": "xxs",
            "@fromTablet": "none",
          }}
          tone="invisible"
        />
        <Button
          isLoading={isLoading}
          onPress={generatePassword}
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          dalej
        </Button>
      </div>
    </Panel>
  );
}
